import type { WmsInstallPrompt } from './wms-app';

export const wmsApp = $state({
  active: false,
  inAppWindow: false,
  installPrompt: null as WmsInstallPrompt | null,
  installing: false,
  installFailed: false
});

export async function installWmsApp(): Promise<void> {
  const prompt = wmsApp.installPrompt;
  if (!prompt || wmsApp.installing) return;
  wmsApp.installing = true;
  wmsApp.installFailed = false;
  try {
    await prompt.prompt();
    await prompt.userChoice;
  } catch {
    wmsApp.installFailed = true;
  } finally {
    wmsApp.installPrompt = null;
    wmsApp.installing = false;
  }
}
